import type { FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import type { sitemapQuery } from "~/queries/__generated__/sitemapQuery.graphql";

import { footerMenuData } from "./data";
import type { FooterMenuData } from "./data";
import { Container, MenuItem, MenuItemBaseLink } from "./styles";

type Props = {
  className?: string;
};

export const PostiesSitemap: FunctionComponent<Props> = ({ className }) => {
  const data = useLazyLoadQuery<sitemapQuery>(
    graphql`
      query sitemapQuery {
        queue(filter: { name: "posties_menu_read" }) {
          items(first: 14) {
            edges {
              node {
                ... on Section {
                  entityId
                  entityUuid
                  urlAlias
                  name
                }
              }
            }
          }
        }
      }
    `,
    {
      name: "posties_menu_read",
    },
  );

  const getClickHandler =
    (label: string | undefined = "") =>
    () => {
      sendGATracking({
        action: "Footer/Click",
        category: "Footer",
        label,
      });
    };

  const readColumn: FooterMenuData = [
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      isLargeSpacing: true,
      name: "Read",
      routeType: "Page",
      urlAlias: "/posties/kids",
    },
    ...(data.queue?.items?.edges?.map(item => ({
      entityId: item.node.entityId ?? "",
      entityUuid: item.node.entityUuid ?? "",
      name: item.node.name ?? "",
      routeType: "Section",
      urlAlias: item.node.urlAlias ?? "",
    })) ?? []),
  ];

  return (
    <Container className={className}>
      {[readColumn, ...footerMenuData].map((menuData, dataIndex) => (
        <MenuItem key={dataIndex}>
          {menuData.map((item, index) => (
            <MenuItemBaseLink
              $isBold={item?.isBold}
              $isLargeSpacing={item?.isLargeSpacing}
              key={index}
              linkEntity={item}
              onClick={getClickHandler(item.name)}
            >
              {item.name}
            </MenuItemBaseLink>
          ))}
        </MenuItem>
      ))}
    </Container>
  );
};

PostiesSitemap.displayName = "PostiesSitemap";
